import React from 'react';
import { Col, Row } from 'antd';
import { filter } from 'ramda';

import { mapIndexed } from 'utils/ramdaAdditions';
import withRole from 'components/common/withRole';
import ExcelDownload from 'components/common/ExcelDownload';
import { SALES } from 'constants/urls';
import withFilterForm from './base/withFilterForm';
import BaseSearchFilter from './base/BaseSearchFilter';
import ShopFilter from './fields/ShopFilter';
import RegionFilter from './fields/RegionFilter';
import BrandFilter from './fields/BrandFilter';
import CityFilter from './fields/CityFilter';
import PromoterFilter from './fields/PromoterFilter';
import SupervisorFilter from './fields/SupervisorFilter';
import ProductFilter from './fields/ProductFilter';
import ProductDepartmentFilter from './fields/ProductDepartmentFilter';
import ProductCategoryFilter from './fields/ProductCategoryFilter';
import ProductGroupFilter from './fields/ProductGroupFilter';
import RangeFilter from './fields/RangeFilter';
import NetworkFilter from './fields/NetworkFilter';

const extraFilterSize = {
    5: 12,
    6: 8,
};

function SalesFilter({ user, isMarketingCoordinator, isSupervisor, isPromoter, values, additionalControls, isMobile }) {
    const controls = isMobile ? (
        <Col span={24} style={{ marginBottom: 10 }}>
            <ExcelDownload query={values} url={SALES} block={isMobile} title='Экспорт' />
        </Col>
    ) : (
        <Col sm={2} xs={24} className="controls-block">
            <ExcelDownload query={values} url={SALES} />
        </Col>
    );

    const shopFilter = {
        supervisor: isSupervisor ? user.id : null,
    };

    const rolesFilters = filter(Boolean, [
        <BrandFilter multiple />,
        !isMarketingCoordinator && !isSupervisor && (
            <RegionFilter multiple />
        ),
        <CityFilter multiple />,
        <NetworkFilter multiple />,
        <ShopFilter filter={shopFilter} multiple />,
        <PromoterFilter multiple />,
        !isSupervisor && (
            <SupervisorFilter multiple />
        )
    ]);

    return (
        <BaseSearchFilter controls={controls} disableSearch={true} additionalControls={additionalControls} disableMobileCollapse={isMobile}>
            { !isPromoter && mapIndexed((filter, index) => filter && (
                <Col key={index} sm={index < 3 ? 8 : extraFilterSize[rolesFilters.length] || 6} xs={24}>
                    {filter}
                </Col>
            ), rolesFilters)}
            <Col xs={24}>
                <Row gutter={5}>
                    <Col sm={4} xs={12}>
                        <ProductDepartmentFilter multiple />
                    </Col>
                    <Col sm={4} xs={12}>
                        <ProductGroupFilter multiple />
                    </Col>
                    <Col sm={4} xs={12}>
                        <ProductCategoryFilter multiple />
                    </Col>
                    <Col sm={4} xs={12}>
                        <ProductFilter multiple />
                    </Col>
                    { !isMobile &&
                        <Col sm={8} xs={24}>
                            <RangeFilter />
                        </Col>
                    }
                </Row>
            </Col>
        </BaseSearchFilter>
    );
}

export default withFilterForm(
    withRole(SalesFilter)
);
